import { Button, Grid, Link } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { TableSortLabel, SvgIcon, Menu } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import SearchBar from "material-ui-search-bar";
import React, { useEffect, useState } from "react";
import Draggable from "react-draggable";
import http from "../services/httpService";
import staticFiles from "../services/staticApi";
import { getDate, searchFilter, handleSort } from "../utils/varialbles";
import Filter from "../components/filerComponent";
import { ReactComponent as FilterLogo } from "../images/filter.svg";
import filterData from "../components/filterCriteria";
import toast from "react-hot-toast";
import Loading from "../components/loading";
const columns = [
  { id: "cust__userID", label: "User ID", minWidth: 170 },
  {
    id: "cust__custfirstname",
    label: "Prospect Name",
    minWidth: 200,
    operation: "concate",
    operand: " ",
    with: "cust__custlastname",
  },
  {
    id: "emp__empfname",
    label: "RM Name",
    minWidth: 150,
    operation: "concate",
    operand: " ",
    with: "emp__emplname",
  },
  {
    id: "service_type",
    label: "Service Type",
    minWidth: 150,
    filter: true,
    filterType: "dropDown",
    conditions: [{ text: "Equal", value: "eq" }],
    options: "data",
    multi: false,
  },
  { id: "discount_type", label: "Discount Type", minWidth: 150 },
  { id: "discount_code", label: "Discount Code", minWidth: 150 },
  { id: "discount_amount", label: "Amount", minWidth: 150, format: "number" },
  {
    id: "expiry",
    label: "Expiry Date",
    minWidth: 150,
    format: "Date",
    filter: true,
    filterType: "date",
    conditions: [
      { text: "less than", value: "lte" },
      { text: "greater than", value: "gte" },
    ],
  },
  { id: "emp__empfname", label: "Creater Name", minWidth: 150 },
  { id: "proof", label: "Proof", minWidth: 150, format: "link" },
  { id: "approval_status", label: "Approval", minWidth: 150 },
  { id: "action", label: "Action", minWidth: 150 },
];

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
});
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}
function DiscountOverView(props) {
  // (props,'props');
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState([]);
  const [searched, setSearched] = React.useState("");
  const [orignalRows, setOriginalRows] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState("cust__createddt");
  const [order, setOrder] = React.useState("asc");
  const [anchorEl, setAnchorEl] = React.useState(null);
  // (Boolean(anchorEl));
  // const isMenuOpen = Boolean(anchorEl);
  const isMenuOpen = anchorEl;
  const form = {
    service_type: "",
    expiry: "",
    expiry__condition: "lte",
  };
  const [formObject, setFormObject] = React.useState(form);
  const clearFilter = () => {
    setFormObject(form);
    setRows(orignalRows);
  };
  const applyFilter = (e) => {
    setAnchorEl(null);
    let tempObject = { ...formObject };
    let tempORows = [...orignalRows];
    let filter = filterData(tempObject, tempORows, columns);
    setRows(filter);
    setPage(0);
  };
  const openFilter = (e) => {
    // let currentTarget = e.currentTarget;
    // setAnchorEl(currentTarget);
    setAnchorEl(true);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const closeFilter = () => {
    setAnchorEl(null);
  };
  const handleChange = (e) => {
    setFormObject({
      ...formObject,
      [e.target.name]: e.target.value,
    });
  };
  const requestSearch = (searchedVal) => {
    let rowsTemp = [...orignalRows];

    setPage(0);
    setRows(searchFilter(searchedVal, rowsTemp));
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };
  const [open, setOpen] = React.useState(false);
  const [proofSrc, setProofSrc] = React.useState(null);
  const handleClose = () => {
    setOpen(false);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleRequestSort = (e, property, format) => {
    let isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let tempRows = [...rows];
    let finalRows = handleSort(property, format, tempRows, isAsc);

    setRows(finalRows);
    setPage(0);
  };
  const openProof = (event, proof) => {
    event.preventDefault();
    setProofSrc(staticFiles + proof);
    setOpen(true);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const viewProspectDetails = (object) => { };
  const changeApprovalStatus = (e, row, status) => {
    http
      .post("/requests", {
        id: row.id,
        approval_status: status,
      })
      .then((response) => {
        toast.success("Updated Successfuly");
        // toast.success(response.data.data);
        setTimeout(() => {
          loadData();
        }, 2000);
      })
      .catch((error) => { console.log('error') });

  };
  const deleteDiscount = (e, row, status) => {
    http
      .get(`/delete_discount_request/${row.id}`)
      .then((response) => {
        loadData();
        toast.success(response.data.data);
      })
      .catch((error) => { console.log('error') });

  };

  useEffect(() => {
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("internalFilter");
    localStorage.removeItem("selectedfiltersdata");
    localStorage.removeItem("selectedinvestorfiltersdata");
    let emp_no = localStorage.getItem("employee_id");
    localStorage.removeItem("ticketFilter");

    loadData();
  }, []);
  function loadData() {
    toast.loading("Please wait...");
    http
      .get("/requests")

      .then((response) => {
        toast.dismiss();
        if (response && response.data && response.data.statusCode === 0) {
          let finalData = [];
          let tempDta = response.data.data;
          let tempStatusDta = tempDta.map((item, index) => {
            const swapValue = (item) => {
              Object.keys(item).forEach((key) => {
                //(Object.keys(item));
                // if (!item[key]) {
                //     item[key] = "N/A";
                // }
              });
            };
            swapValue(item);

            if (item.proof === "") {
              finalData.push((item.proof = "N/A"));
            } else {
              finalData.push(item.proof);
            }

            if (item.emp__empfname === null) {
              finalData.push((item.emp__empfname = "N/A"));
            } else {
              finalData.push(item.emp__empfname);
            }
            if (item.emp__emplname === null) {
              finalData.push((item.emp__emplname = "N/A"));
            } else {
              finalData.push(item.emp__emplname);
            }
            return item;
          });
          setOriginalRows(tempDta);
          setRows(tempDta);
        }
      })
      .catch((error) => { console.log('error') });

  }
  return (
    <>
      <Paper className={classes.root}>
        <Grid container style={{ justifyContent: "space-between", margin: 10 }}>
          <Grid item xs={3}>
            <SearchBar
              value={searched}
              onChange={(searchVal) => requestSearch(searchVal)}
              onCancelSearch={() => cancelSearch()}
              style={{ height: "unset", padding: "5px", marginTop: 5 }}
            />
          </Grid>
          <Grid container xs={5} style={{ flexWrap: "nowrap" }}>
            <TablePagination
              rowsPerPageOptions={[10, 50, 100, 1500]}
              component="div"
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
            <div
              style={{
                display: "flex",
                marginLeft: 10,
                cursor: "pointer",
                alignItems: "center",
              }}
              onClick={openFilter}
            >
              <p>Filter</p>
              <SvgIcon title={"filter"} style={{ marginLeft: 5 }}>
                <FilterLogo />
              </SvgIcon>
            </div>
            <Menu
              anchorEl={anchorEl}
              id={"Filtermenu"}
              keepMounted
              open={isMenuOpen}
              onClose={handleMenuClose}
              getContentAnchorEl={null}
              transformOrigin={{ horizontal: "rigth", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "top" }}
              style={{ top: 250, left: 0 }}
            >
              <Filter
                columns={columns}
                applyFilter={applyFilter}
                orignalRows={orignalRows}
                handleChange={handleChange}
                formObject={formObject}
                clearFilter={clearFilter}
                closeFilter={closeFilter}
              />
            </Menu>
          </Grid>
        </Grid>
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id + column.label.trim()}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={(e) =>
                        handleRequestSort(e, column.id, column.format)
                      }
                    >
                      {column.label}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length !== 0 ? (
                <>
                  {rows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={index + "a"}
                        >
                          {columns.map((column, index) => {
                            const value = row[column.id];
                            return (
                              <TableCell
                                key={index + column.id + column.label.trim()}
                                align={column.align}
                              >
                                {column.format && typeof value === "number" ? (
                                  Number(value)
                                ) : column.id === "detailsButton" ? (
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    style={{ borderRadius: 20 }}
                                    onClick={() => viewProspectDetails(row)}
                                  >
                                    View Details
                                  </Button>
                                ) : column.format === "Date" ? (
                                  getDate(value)
                                ) : column.operation &&
                                  column.operation === "concate" &&
                                  value !== "N/A" ? (
                                  value + column.operand + row[column.with]
                                ) : column.label === "Approval" &&
                                  value === null ? (
                                  <Grid container>
                                    <Grid item xs={12}>
                                      <Button
                                        variant="contained"
                                        style={{
                                          borderRadius: 20,
                                          backgroundColor: "#11BE74",
                                          color: "#ffffff",
                                          width: "126px",
                                        }}
                                        onClick={(e) =>
                                          changeApprovalStatus(e, row, 1)
                                        }
                                      >
                                        Aprove
                                      </Button>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      style={{ marginTop: 10 }}
                                    >
                                      <Button
                                        variant="contained"
                                        style={{
                                          borderRadius: 20,
                                          backgroundColor: "#D92212",
                                          color: "#ffffff",
                                          width: "126px",
                                        }}
                                        onClick={(e) =>
                                          changeApprovalStatus(e, row, 0)
                                        }
                                      >
                                        Disapprove
                                      </Button>
                                    </Grid>
                                  </Grid>
                                ) : column.label === "Approval" &&
                                  value === true ? (
                                  "Approved"
                                ) : column.label === "Approval" &&
                                  value === false ? (
                                  "Disapproved"
                                ) : column.format === "link" &&
                                  value &&
                                  value !== "N/A" ? (
                                  <Link
                                    variant="body2"
                                    onClick={(e) => openProof(e, value)}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {value}
                                  </Link>
                                ) : column.id === "action" ? (
                                  <Button
                                    variant="contained"
                                    style={{
                                      borderRadius: 20,
                                      backgroundColor: "#D92212",
                                      color: "#ffffff",
                                      width: "126px",
                                    }}
                                    onClick={(e) => deleteDiscount(e, row, 0)}
                                  >
                                    Delete
                                  </Button>
                                ) : (
                                  value
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                </>
              ) : (
                <TableCell
                  colspan="7"
                  style={{ "text-align": "center", margin: "10px 0px" }}
                >
                  Data Not Available
                </TableCell>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Dialog
          open={open}
          onClose={handleClose}
          PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
          maxWidth="md"
          fullWidth
        >
          {/* <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    Proof
                </DialogTitle> */}
          <DialogActions style={{ background: "#f1f1f1" }}>
            <Button onClick={handleClose} variant="outlined">
              x
            </Button>
          </DialogActions>
          <DialogContent
            style={{
              background: "#f1f1f1",
              paddingBottom: "3rem",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <img
              src={proofSrc}
              alt="proof"
              style={{
                height: "100%",
                maxHeight: "800px",
                maxWidth: "800px",
                minHeight: "300px",
              }}
            />
            {/* <img src={proofSrc} alt="proof" style={{height: '100%', maxHeight: '800px', maxWidth: '1200px', minHeight: '400px'}} /> */}
          </DialogContent>
        </Dialog>
      </Paper>
    </>
  );
}
export default DiscountOverView;
